import { combineReducers } from 'redux';
import auth from './reducer/authReducer';
import userManagement from './UserManagement/reducer';
import project from './Project/reducer';
import setupData from './Project/setupData/reducer';
import materialsData from './Project/materialsData/reducer';
import registryData from './Project/registryData/reducer';
import weldData from './WeldData/reducer';
import map from './reducer/mapReducer';
import productionData from './ProductionData/reducer';
import { teamMembersReducer as teamMembers } from './TeamMembers';
import deviceReducer from './device/reducer';
import userTableLayoutReducer from './UserTableLayout/reducer';
import reportDraftsReducer from './ReportDrafts/reducer';
import ndtAnalyticsReducer from './NDT Analytics/reducer';
import coatingPumphouseReducer from './CoatingPumphouse/reducer';
import spoolsbaseReducer from './Spoolsbase/reducer';
import pipeMillReportReducer from './Project/pipeMillReport/reducer';
import { SIGNOUT } from './types';

const appReducer = combineReducers({
  auth,
  userManagement,
  project,
  setupData,
  materialsData,
  registryData,
  weldData,
  map,
  productionData,
  teamMembers,
  deviceData: deviceReducer,
  userTableLayout: userTableLayoutReducer,
  reportDrafts: reportDraftsReducer,
  ndtAnalytics: ndtAnalyticsReducer,
  coatingPumphouse: coatingPumphouseReducer,
  spoolsbase: spoolsbaseReducer,
  pipeMillReport: pipeMillReportReducer,
});

const rootReducer = (state, action) => {
  const newState = action.type === SIGNOUT ? undefined : state;
  return appReducer(newState, action);
};

export default rootReducer;
